module.exports = __webpack_public_path__ + "img/newtaiyo4.e223ff55.png";